import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { post } from "../../../util/axiosLib";
import { logger } from "../../../util/logger";

// components
import Sidemenu from '../../../components/sidemenu'
import Header from '../../../components/dashHeader'

//css 
import '../../styles/dashboard/Home.css'

// assets
import Arrow from '../../../assets/icons/forward.svg'
import Back from '../../../assets/svg/back-arrow.svg'
import Check2 from '../../../assets/icons/pop-check.svg'
import Check0 from '../../../assets/icons/check0.svg'
import Cancel from "../../../assets/icons/sm-x.svg";
import Load from "../../../assets/svg/other/loading2.svg";


export default class ChangeraDeposit extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
            popUpClicked: false,
            enterPin:false,
            fiatCurrency: ""
        };
    
        this.token = localStorage.getItem("tokenset");
    }

    componentDidMount(){
      const status = window.location.pathname.substr(31)
     
      this.setState({ status })
    }
    
    handleInputChange = async (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
    
        await this.setState({
          [name]: value,
        });
    
        const errmsg = document.getElementById("error-info2");
        errmsg.classList.remove("err-auth-on");
        this.setState({ incorrectError: " " });
    
        if (name === "amount") {
          const numberRegex = /(?=[a-zA-Z])/;
          if(numberRegex.test(value) || value < 0){
            const errmsg = document.getElementById("error-info2");
            errmsg.classList.add("err-auth-on");
            this.setState({ incorrectError: "Please enter only valid numbers" });
          }
    
        }

        if (this.state.fiatCurrency!=="" && this.state.amount > 0) {
          const ebtn = document.getElementById("actionBtn");
          await ebtn.classList.remove("e-disable");
        } else {
          const ebtn = document.getElementById("actionBtn");
          await ebtn.classList.add("e-disable");
        }
        // const loaded2 = document.getElementById("loadla");
        // loaded2.classList.add("load-aa-on");
      
      };

    handleSubmit = async (event) => {
        event.preventDefault();
        
        // this.setState({ 
        //     enterPin: true
        // });
       
        const ebtn = document.getElementById("actionBtn");
        await ebtn.classList.add("e-disable");
    
        //loading..
        const loaded2 = document.getElementById("loadla");
        loaded2.classList.add("load-aa-on");
    
        try {
          event.preventDefault();
          const obj = {
            currency: this.state.fiatCurrency,
            amount: this.state.amount,
            depositType : "changera",
            callbackSuccessUrl: `${process.env.REACT_APP_DOMAIN}/dashboard/homechangeradeposit/depositSuccess`,
            callbackFailedUrl: `${process.env.REACT_APP_DOMAIN}/dashboard/homechangeradeposit/depositFailed`
          };
    
          const headers = {
            authorization: `${this.token}`,
            "Content-Type": "application/json",
          };
    
          this.setState({
            processing: true,
          });
    
          const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/deposit`;
    
          const depositReq = await post(endpoint, obj, headers);
    
          logger("OBJ:: ", depositReq.data.data.url);
          window.location = depositReq.data.data.url;
          
            // this.setState({ 
            //     popUpClicked: true,
            //     enterPin: false
            // });
            //logger(depositReq.data.data.url);
          
        } catch (err) {
          logger("Withdraw ERROR::: ", err);
          if (err.isAxiosError) {
            // const errData = err.response;
            // const errmsg = document.getElementById("error-info");
            // errmsg.classList.add("error-info-on");
    
            // loaded2.classList.remove("load-aa-on");
            // ebtn.classList.remove("e-disable");
    
            if (err.isAxiosError) {
                this.setState({
                  //errorMessage: errData.data.error,
                  processing: false,
                });
              //}
            } else {
              this.setState({
                //errorMessage: errData.data.error,
                processing: false,
              });
             
            }
          }
        }
    }

    handlePinSubmit = async (event) => {
        const ebtn = document.getElementById("summaryBtn");
        await ebtn.classList.add("e-disable");
    
        //loading..
        const loaded2 = document.getElementById("loadla");
        loaded2.classList.add("load-aa-on");
    
        try {
          event.preventDefault();
          const obj = {
            currency: this.state.fiatCurrency,
            amount: this.state.amount,
            depositType : "changera"
          };
    
          const headers = {
            authorization: `${this.token}`,
            "Content-Type": "application/json",
          };
    
          this.setState({
            processing: true,
          });
    
          const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/deposit`;
    
          const depositReq = await post(endpoint, obj, headers);
    
          logger("OBJ:: ", depositReq);
          window.location = depositReq.data.data.url;
          
            // this.setState({ 
            //     popUpClicked: true,
            //     enterPin: false
            // });
            logger(depositReq.data.data.url);
          
        } catch (err) {
          logger("Withdraw ERROR::: ", err);
          if (err.isAxiosError) {
            const errData = err.response;
            const errmsg = document.getElementById("error-info");
            errmsg.classList.add("error-info-on");
    
            loaded2.classList.remove("load-aa-on");
            ebtn.classList.remove("e-disable");
    
            if (err.isAxiosError) {
                this.setState({
                  errorMessage: errData.data.error,
                  processing: false,
                });
              //}
            } else {
              this.setState({
                errorMessage: errData.data.error,
                processing: false,
              });
             
            }
          }
        }
      }

    createPin = async () => {
        localStorage.setItem("changePinStatus", true)
    
        setTimeout(() => {
            window.location = "/dashboard/accountedit"
        }, 1000);
    }
    
    handleRemove = event => {
        event.preventDefault();
        this.setState({ status : "none" });
        this.setState({popUpRemove: true})
        setTimeout(function(){ 
            document.querySelector('#rem-box').style.display = "none" 
        }, 1000);
    }

    render() {

        const currentPage = "Home";

        return (
            <div>
                <Sidemenu currentPage={currentPage} />
                <Header />

                {this.state.enterPin ? (
                    <div>
                        <div className="overlay3 animate__animated animate__fadeIn "></div>
                        <section className="summaryclicked">
                        <div className="summaryclicked-box2 animate__animated animate__slideInDown">
                            <div className="sc-top">
                            <h2 className="">Enter Pin</h2>
                            <img
                                onClick={() => this.setState({ enterPin: false })}
                                src={Cancel}
                                alt="close"
                            />
                            </div>
                            <form className="wallet-withdraw-form" onSubmit={this.handlePinSubmit}>
                                <div className="ww-inputs">
                                    <p>Please enter your pin for withdrawal</p>
                                    <input type="password" 
                                    placeholder="Enter your pin"
                                    id="pin"
                                    name="pin"
                                    defaultValue={this.state.pin}
                                    onChange={this.handleInputChange }
                                    maxLength="6"
                                    required
                                    />
                                    {/* <span className="password-btn">
                                        <img className="show-icon" id="password-btn" src={Eye} alt="show"  />
                                    </span> */}
                                    
                                </div>
                                {/* <span className="password-btn">
                                    <img
                                    className="show-icon"
                                    id="password-btn"
                                    src={Eye}
                                    alt="show"
                                    />
                                </span> */}
                                <p className="tiny-txt3 left-m1">
                                    (Don't have a pin? <span className="pointer green"
                                    onClick={this.createPin}>Create one</span>)
                                </p>
                    
                                <button
                                //onClick={this.handlePinSubmit}
                                className="summaryclicked-btn"
                                id="summaryBtn"
                                >
                                Submit
                                </button>
                                <div id="loadla" className="load-aa" >
                                <img src={Load} alt="loading" />
                                </div>
                            </form>
                            <div
                            id="error-info"
                            className="error-info animate__animated animate__fadeIn "
                            >
                            <p>{this.state.errorMessage}</p>
                            </div>
                        
                        </div>
                        </section>
                    </div>
                ) : null}

                {this.state.status === "depositSuccess" && (
                    <div  id="rem-box" >
                        <div className="overlay animate__animated animate__fadeIn "></div>
                        <section className="popup">
                            <div className="popup-box animate__animated animate__slideInDown">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check2} alt="" />
                                </div>
                               <h2>{this.state.amount}gggg</h2>
                               <p className="popup-success">Wallet funded Successfully!</p>
                               <p onClick={this.handleRemove} className="popup-close">Close</p>
                               {/* {document.querySelector('#rem-box').style.display = "block"} */}
                            </div>
                        </section>
                    </div>
                )}

                {this.state.status === "depositFailed" && (
                    <div id="rem-box" >
                        <div className="overlay animate__animated animate__fadeIn "></div>
                        <section className="popup">
                            <div className="popup-box  redshade animate__animated animate__slideInDown">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check0} alt="" />
                                </div>
                               <h2>{this.state.amount}</h2>
                               <p className="popup-success">Wallet funding failed,<br /> Please try again.</p>
                               <p onClick={(e)=>this.setState({status : "none"})} className="popup-close">Close</p>
                               {/* {document.querySelector('#rem-box').style.display = "block"} */}
                            </div>
                        </section>
                    </div>
                )}

                {this.state.popUpRemove === true && (
                    <div id="rem-box">
                        <div className="overlay animate__animated animate__fadeOut "></div>
                        <section className="popup">
                            <div className="popup-box animate__animated animate__backOutUp">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check2} alt="" />
                                </div>
                                <h2>{this.state.amount}</h2>
                               <p className="popup-success">Wallet funded Successfully!</p>
                               <p onClick={this.handleRemove} className="popup-close">Close</p>
                            </div>
                        </section>
                    </div>
                )}


                <section className="home">
                    <div
                    id="error-info2"
                    className="err-auth zindex animate__animated animate__slideInDown">
                        <p>
                            <strong>{this.state.incorrectError}</strong>
                        </p>
                    </div>
                    <div className="home-container">
                        <div className="home-buy-content">
                            <Link to="/dashboard/homefundwallet">
                            <img src={Back} className="w-backarrow" alt="back" />
                            </Link>
                            <h1> Changera Deposit </h1>
                            <div className="home-nav">
                                <Link to="/dashboard/home" className="right-e"><p className="ash"> Home </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <Link to="/dashboard/homefundwallet" className="right-e"><p className="ash"> Fund Wallet </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <p><span className="bold"> Changera Deposit</span></p>
                            </div>
                            <div className="depo-box">
                                <form onSubmit={this.handleSubmit} className="cardpayment-form">
                                    <div className="p2p-inputs">
                                        <input name="amount" onChange={this.handleInputChange}
                                        type="text" placeholder="Amount"/>
                                    </div>
                                    <div className="p2p-inputs">
                                        <select
                                            name="fiatCurrency"
                                            className="depo-select"
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.fiatCurrency}
                                            required
                                            >
                                            <option value="">Select Currency</option>
                                            <option value="ngn">Nigerian Naira (NGN)</option>
                                            <option value="ghs">Ghana Cedis (GHS)</option>
                                        </select>
                                        {/* <input type="text" /> */}
                                    </div>
                                    {/* <div className="cardinfos-box">
                                        <input className="carddate-input right-m2" type="text" placeholder="MM/YY" maxLength="5" />
                                        <input className="cardcode-input" type="text" placeholder="CVV" maxLength="3" />
                                    </div> */}
                                    <button  id="actionBtn"
                                    className="cardinfo-submit e-disable" type="submit">
                                        Fund Wallet
                                    </button>
                                    <div id="loadla" className="load-aa" >
                                        <img src={Load} alt="loading" />
                                    </div>
                                </form>
                            </div>
                            
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
